/* eslint-disable */
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import { compose } from 'redux';
import withServices from '../../Contexts/Services/WithServices.context';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import Footer from '../Footer/Footer.component';
import TermsPropTypes from './Terms.component.props';
import TermsStyles from './Terms.component.styles';

/**
 * TermsComponent
 * @export
 * @class TermsComponent
 * @extends {React.Component<TermsComponentComposedProps, TermsComponentState>}
 */
export class TermsComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<TermsComponentProps>}
   * @memberof TermsComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`Terms`}
   * @memberof TermsComponent
   */
  static displayName = `Terms`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof TermsComponent
   */
  static propTypes = TermsPropTypes;

  /**
   * Data specific to the `<TermsComponent />` instance
   * @type {TermsComponentState}
   * @memberof TermsComponent
   */
  state = {};

  /**
   * Render the component
   * @returns {React.Component} The rendered `<TermsComponent />`
   * @memberof TermsComponent
   */
  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        {/* <ReactMarkdown className={classes.terms} source={content} />
         */}
        <div className={classes.terms}>
          <p>By using this website you agree to be bound by these conditions. If you do not agree with them, you are not authorised to use the website.</p>

          <ol>
            <li>
              This website and its contents are subject to copyright which is owned by Boral or a third party. Boral does not grant you any intellectual
              property rights in this website, its applications, interface or contents. You must not use any trade mark displayed on this website without proper
              authorisation.
            </li>

            <li>
              We do not without proper authorisation warrant the accuracy or completeness of any information you derive from this website and we exclude
              liability for loss or damage arising from any errors or omissions in this website or your use of this website (including any interference with or
              damage to your computer system). If any liability is not able to be excluded by law, we limit our liability to the resupply of the relevant
              information or services.
            </li>

            <li>
              You release Boral, its related bodies corporate and affiliates to the fullest extent permitted by law from any and all claims arising out of or
              related to the use of material or information made available through this website.
            </li>

            <li>
              Any prices listed on this website and terms and conditions of any kind relating to products displayed on this site may not be current or complete
              and therefore under no circumstances constitute an offer or undertaking by Boral. We make no representation that the products listed in this site
              are currently available online or at any physical retail location. We reserve the right to change any information on this website at any time
              including, but not limited to, prices.
            </li>

            <li>
              This website may contain links to external Internet websites. Boral does not sponsor, guarantee or approve of any material or representations in
              those websites. Nor do we warrant that material on linked sites is free of any computer virus, defects or infringements.
            </li>

            <li>
              Links to this site are permitted, provided the full html page is loaded. Links to individual graphics or to areas that are considered
              &quot;security areas&quot; that bypass any security protection or password protect that Boral establishes are expressly prohibited. If you wish to
              use a graphic to link to this site please contact us.
            </li>

            <li>
              You must only use this website, and you must only display, copy, distribute download and print portions of this website for your own personal use.
              You must not attempt to change, reproduce, add to, remove, hack or interfere with this website or its material.
            </li>

            <li>
              We cannot guarantee any file, data or program available for download from this website (or any linked website) is free of viruses and you assume
              the risk of any damage to your computer as a result of using this website. This website may be inaccessible from time to time due to events
              outside Boral&#39;s control or maintenance requirements.
            </li>

            <li>
              If we collect your personal information, we do so subject to the terms of our Privacy Policy, details of which are available{` `}
              <a href="https://www.boral.com.au/privacy-policy">here</a>.
            </li>

            <li>
              We may use cookies to gather data in relation to this website and you consent to us doing so (although you may be able to disable cookies on your
              web browser).
            </li>

            <li>
              These conditions are governed by laws of the State of New South Wales, Australia. You submit to the non-exclusive jurisdiction of the courts of
              that State.
            </li>
          </ol>
        </div>
        <Footer className={classes.footer} />
      </React.Fragment>
    );
  }
}

/** @type {React.ComponentClass<TermsComponentProps>} */
const Terms = compose(
  withServices,
  withStyles(themeCreateInjectableStyles(TermsStyles), { withTheme: true }),
)(TermsComponent);
export default Terms;
